import { render } from "./envelope.vue?vue&type=template&id=60b05f8c"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/envelope.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60b05f8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60b05f8c', __exports__)) {
    api.reload('60b05f8c', __exports__)
  }
  
  module.hot.accept("./envelope.vue?vue&type=template&id=60b05f8c", () => {
    api.rerender('60b05f8c', render)
  })

}


export default __exports__